import * as React from 'react';

const AttachmentIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.8 7.2L7.2 12.8C6.54 13.46 6.54 14.54 7.2 15.2C7.86 15.86 8.94 15.86 9.6 15.2L16.6 8.2C17.92 6.88 17.92 4.78 16.6 3.46C15.28 2.14 13.18 2.14 11.86 3.46L4.86 10.46C2.88 12.44 2.88 15.66 4.86 17.64C6.84 19.62 10.06 19.62 12.04 17.64L17.64 12.04"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default AttachmentIcon; 